var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0001 5.03256C29.0853 5.03256 33.872 7.01842 37.4764 10.6113C41.0693 14.2157 43.0551 19.0024 43.0551 24.0875C43.0551 29.1727 41.0693 33.9594 37.4764 37.5638C33.872 41.1567 29.0853 43.1425 24.0001 43.1425C18.915 43.1425 14.1283 41.1567 10.5239 37.5638C6.93101 33.9594 4.94516 29.1727 4.94516 24.0875C4.94516 19.0024 6.93101 14.2157 10.5239 10.6113C14.1283 7.01842 18.915 5.03256 24.0001 5.03256ZM24.0001 0.211426C10.8109 0.211426 0.124023 10.8983 0.124023 24.0875C0.124023 37.2768 10.8109 47.9637 24.0001 47.9637C37.1894 47.9637 47.8763 37.2768 47.8763 24.0875C47.8763 10.8983 37.1894 0.211426 24.0001 0.211426Z",
    fill: "#EA5383"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9386 32.6852L32.5983 36.0255L24.0006 27.4278L15.4029 36.0255L12.0625 32.6852L20.6602 24.0875L12.0625 15.4898L15.4029 12.1494L24.0006 20.7471L32.5983 12.1494L35.9386 15.4898L27.3409 24.0875L35.9386 32.6852Z",
    fill: "#EA5383"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.7b288d7bd7326b031bff948ce6593890.svg";
export { ForwardRef as ReactComponent };